import {
  Checkmark
} from "./chunk-62PCOUDV.mjs";

// src/select/src/select-item.tsx
import * as React from "react";
import * as RadixSelectPrimitive from "@radix-ui/react-select";
import { jsx, jsxs } from "react/jsx-runtime";
var SelectItem = React.forwardRef(
  ({ children, ...rest }, forwardedRef) => {
    return /* @__PURE__ */ jsxs(
      RadixSelectPrimitive.Item,
      {
        className: "flex cursor-pointer select-none justify-between gap-4 rounded-sm px-2 py-1 text-sm\n        text-surface-dark data-[disabled]:pointer-events-none data-[highlighted]:bg-surface-subtle\n        data-[disabled]:text-interactive-disabled data-[highlighted]:text-surface-dark data-[highlighted]:outline-none",
        ...rest,
        ref: forwardedRef,
        children: [
          /* @__PURE__ */ jsx(RadixSelectPrimitive.ItemText, { children }),
          /* @__PURE__ */ jsx(RadixSelectPrimitive.ItemIndicator, { className: "rounded [&_svg]:size-5", children: /* @__PURE__ */ jsx(Checkmark, {}) })
        ]
      }
    );
  }
);

export {
  SelectItem
};
